/**
 * 海外版区域配置
 * 所有海外版特有的数据、导航、联系方式等都在这里定义
 * 与国内版的差异通过此配置体现，而非通过代码分支
 */
export default {
  // 区域标识
  region: 'global',
  // 区域显示名
  name: 'Global',
  // 游戏名称（海外版可能不同）
  gameName: 'Code: Immortal Path',
  // 公司名称
  companyName: 'ShengJianYou',
  // 默认语言
  defaultLocale: 'en',

  // 导航菜单（海外版没有"社区"入口）
  navItems: [
    { titleKey: 'message.home', path: '/global/home', children: [] },
    {
      titleKey: 'message.about',
      path: '/global/about',
      children: [
        { title: 'About Us', path: '/global/about' }
      ]
    },
    { titleKey: 'message.contact', path: '/global/contact', children: [] }
  ],

  // 可用页面（海外版没有 community）
  pages: ['home', 'about', 'contact', 'news', 'games', 'download'],

  // 页脚信息（海外版没有备案号）
  footer: {
    icp: ''
  },

  // 联系方式（海外版不同）
  contactInfo: [
    {
      title: 'Business Partnership',
      content: [
        { text: 'global@shengjianyou.com' },
        { text: 'Business and partnership inquiries' }
      ]
    },
    {
      title: 'Careers',
      content: [
        { text: 'careers@shengjianyou.com' },
        { text: 'Join our talented team' }
      ]
    },
    {
      title: 'Support',
      content: [
        { text: 'support@shengjianyou.com' },
        { text: 'Feedback and suggestions' }
      ]
    },
    {
      title: 'Office',
      content: [
        { text: 'Singapore' },
        { text: 'Asia Pacific HQ' }
      ]
    }
  ],

  // 下载渠道（海外版不同）
  downloadChannels: [
    { name: 'App Store', type: 'ios' },
    { name: 'Google Play', type: 'android' },
    { name: 'Steam', type: 'steam' }
  ],

  // 系统要求
  systemRequirements: [
    'OS: Windows 10 64-bit',
    'Processor: Intel i5 or equivalent',
    'Memory: 8GB RAM',
    'Graphics: GTX 1060 or equivalent',
    'Storage: 50GB available space'
  ],

  // 社区平台（海外版不同 - Discord 等）
  communityPlatforms: [
    { title: 'Discord', desc: 'Join our community on Discord', button: 'Join Server' },
    { title: 'Twitter / X', desc: 'Follow us for the latest updates', button: 'Follow Us' },
    { title: 'Support', desc: 'Need help? Contact our support team', button: 'Get Support' }
  ],

  // 首页 Hero 区域
  hero: {
    title: 'Code: Immortal Path',
    subtitle: 'The Ultimate Experience — Coming Soon'
  },

  // 首页产品特色
  features: [
    { title: 'Core Features', desc: 'Cutting-edge algorithms to solve customer needs' },
    { title: 'User Experience', desc: 'Smooth interaction, seamless enjoyment' },
    { title: 'Community Building', desc: 'Stable platform to attract quality users' }
  ],

  // 首页快捷入口
  additionalFeatures: [
    { title: 'About Us', desc: 'Learn about our company', path: '/global/about' },
    { title: 'Join Us', desc: 'Career opportunities', path: '/global/contact' }
  ],

  // 关于页面
  about: {
    intro: 'ShengJianYou is an innovative tech company focused on developing and operating high-quality products. We are committed to providing premium products to users worldwide, blending traditional culture with modern technology.',
    team: 'Our core team is experienced and passionate, with members from renowned tech companies worldwide. We bring extensive expertise in product R&D, operations, and marketing. We value talent development and provide broad growth opportunities.',
    philosophy: 'We adhere to the philosophy of "Quality First, Innovation as Soul" — ensuring product excellence while continuously exploring new technologies to stand out in a competitive market.'
  },

  // 新闻列表
  newsList: [
    { id: 1, title: 'New Version Coming Soon', date: '2023-10-01', summary: 'A brand new version is on the way. Stay tuned for more content!' },
    { id: 2, title: 'Holiday Event Live', date: '2023-09-25', summary: 'Rich in-game events during the holidays with amazing rewards!' },
    { id: 3, title: 'Server Maintenance Notice', date: '2023-09-20', summary: 'Servers will undergo maintenance at midnight for a better experience.' }
  ],

  // 游戏特色
  gameFeatures: [
    { title: 'Class System', desc: 'Multiple classes with unique skills and playstyles' },
    { title: 'PvP Arena', desc: 'Intense player battles to showcase your skills' },
    { title: 'Dungeon Raids', desc: 'Team up to challenge powerful bosses' },
    { title: 'Equipment System', desc: 'Diverse equipment acquisition and enhancement' }
  ],

  // 新闻轮播数据
  carouselNews: [
    { title: 'About Us', date: '2023-08-25', url: '/global/about' }
  ]
}
